import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material'

const ModalConfirmacao = ({ data, close }) => {
  const handleTrue = () => {
    close(true)
  }

  const handleFalse = () => {
    close(false)
  }

  return (
    <Dialog maxWidth="sm" open={true} onClose={handleFalse}>
      <DialogTitle>{data?.titulo}</DialogTitle>
      <DialogActions>
        <Button onClick={handleFalse}>Cancelar</Button>
        <Button variant="contained" onClick={handleTrue} autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalConfirmacao
